import { monthMap, monthOptions } from "../../../config";

const generateField = () => {
  return monthOptions.map((item) => ({
    name: String(item.value),
    label: item.label,
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  }));
};

export const tableConfig = [
  {
    name: "name",
    label: "Kategori",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "200px", minWidth: "200px", textAlign: "center" },
      }),
    },
  },
  ...generateField(),
  {
    name: "13",
    label: "YEAR TO DATE (YYYY)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
];

export function transformMonthlyData(data) {
  if (!Array.isArray(data) || data.length === 0) return [];

  // get all keys except "month"
  const metrics = Object.keys(data[0]).filter((k) => k !== "month");

  return metrics.map((metric) => {
    const result = { name: CONSTANT_NAME[metric] };

    data.forEach((item) => {
      result[item.month] = item[metric];
    });

    return result;
  });
}

export const CONSTANT_NAME = {
  unitEntri: "Unit Entri",
  unitNonService: "Unit Non Servis",
  unitService: "Unit Servis",
  nonKPB: "Unit Non KPB",
  kpb: "KPB",
  kpb1: "KPB 1",
  kpb2: "KPB 2",
  kpb3: "KPB 3",
  kpb4: "KPB 4",
};

export function generatePayloadPrint(data) {
  return Object.entries(data).reduce((acc, [key, val]) => {
    const monthLabel = monthMap[key];

    if (monthLabel) {
      acc[monthLabel] = val;
    } else {
      acc[key] = val;
    }

    return acc;
  }, {});
}
